import React, { useEffect, useState } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import Config from "../../config/config";
import CourseCard from '../../components/CourseCard';
import LmsService from '../../services/LmsService';
import DamService from '../../services/DamService';
import ChatService from "../../services/ChatService";
import { addToDataLayerGTM } from '../../utils/addToDataLayerGTM'

import Button from "../../components/CustomButton/CustomButton.jsx";
import Spinner from "../../components/Spinner";

import thumbnailDefault from "../../assets/img/sem-imagem.png";

const Search = () => {

  var search_url = window.location.search.replace(window.location.hash, "");
  const search_term = decodeURIComponent(search_url.replace("?s=", "").split('+').join(' ')).normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();

  const windowWidth = window.innerWidth;

  var settings_carousel = {
    autoplay: false,
    dots: false,
    speed: 500,
    slidesToShow: (windowWidth <= 987 ? 2 : 4),
    slidesToScroll: (windowWidth <= 987 ? 2 : 4)
  };

  const lmsService = new LmsService();
  const damService = new DamService();
  const chatService = new ChatService();

  const [courseSearch, setCourseSearch] = useState([]);
  const [videoSearch, setVideoSearch] = useState([]);
  const [assetSearch, setAssetSearch] = useState([]);
  const [aulasGravadasSearch, setAulasGravadasSearch] = useState([]);
  const [chatSearch, setChatSearch] = useState([]);
  const [trailSearch, setTrailSearch] = useState([]);

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    addToDataLayerGTM({
      'event' : 'step_change',
      'etapa' : '/resultado-busca/',
    });
    async function getSearchResult() {
      try {
        setLoading(true);

        const [chatResponse, courseResponse, assetResponse, videoResponse, aulasGravadasResponse, trailResponse] = await Promise.all([
          chatService.searchChat(search_term),
          lmsService.searchCourse(search_term),
          damService.searchAsset(search_term),
          lmsService.searchVideo(search_term),
          lmsService.searchAulasGravadas(search_term),
          lmsService.searchTrails(search_term),
        ]);

        setCourseSearch(courseResponse.data.search_courses_collections.courses);
        setAssetSearch(assetResponse.data.search_assets_collections.assets);
        setVideoSearch(videoResponse.data.videos_collections_search.videos);
        setAulasGravadasSearch(aulasGravadasResponse.data.videos_list_by_category_search.videos);
        setChatSearch(chatResponse.data.chats_list_search.chats);
        setTrailSearch(trailResponse.data.trail_list_search.trailitems);

      } catch (err) {
        setError("Ocorreu um erro ao realizar sua busca.");
        addToDataLayerGTM({
          'event' : 'erro',
          'etapa' : 'erro ao realizar busca'
        });
      } finally {
        setLoading(false);
      }
    }

    getSearchResult();
  }, []);

  return (
      <div className="content">
        <div class="container">
          {error && (
              <div>{error}</div>
          )}

          {loading ? (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 200 }}>
                <Spinner />
              </div>
          ) : (
              <div>
                <Row>
                  <Col md={12}>
                    <h1>Busca por "{search_term}"</h1>
                  </Col>
                </Row>

                {(!courseSearch.length && !assetSearch.length && !videoSearch.length
                && !aulasGravadasSearch.length && !trailSearch.length && !chatSearch.length) && (
                <div>Nenhum conteúdo encontrado.</div>
                )}

                {courseSearch.length > 0 && (
                    <Grid className="rowCarousel">
                      <div>
                        <Row>
                          <Col md={12}>
                            <h2 style={{ margin: 0 }}>Cursos</h2>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <Slider {...settings_carousel} infinite={courseSearch.length > 3 ? true : false}>
                              {courseSearch.map((item) => (
                                <div>
                                  <CourseCard
                                    key={item.id} 
                                    item={item}
                                    href={"/#/curso/" + item.id}
                                    src={(item.thumbnail == null ? thumbnailDefault : Config.baseUrl + "/lms/assets/" + item.thumbnail)}
                                    variables={{ course_trails:true }}
                                  />
                                </div>
                              ))}
                            </Slider>
                          </Col>
                        </Row>
                      </div>
                    </Grid>
                )}

                {assetSearch.length > 0 && (
                    <Grid className="rowCarousel">
                      <div>
                        <Row>
                          <Col md={12}>
                            <h2 style={{ margin: 0 }}>Conteúdos digitais</h2>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <Slider {...settings_carousel} infinite={assetSearch.length > 3 ? true : false}>
                              {assetSearch.map((item) => (
                                  <div className="media media_asset">
                                    <div>
                                      <h2>{item.title}</h2>
                                      <a
                                          data-gtm-type="click"
                                          data-gtm-clicktype="download"
                                          data-gtm-search="result"
                                          data-gtm-name={item.title}
                                          href={Config.baseUrl + "/dam/assets/" + item.asset}
                                          download
                                          target="_blank"
                                      >
                                        <Button bsStyle="info">Baixe aqui</Button>
                                      </a>
                                    </div>
                                  </div>
                              ))}
                            </Slider>
                          </Col>
                        </Row>
                      </div>
                    </Grid>
                )}

                {videoSearch.length > 0 && (
                    <Grid className="rowCarousel">
                      <div>
                        <Row>
                          <Col md={12}>
                            <h2 style={{ margin: 0 }}>Vídeos</h2>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <Slider {...settings_carousel} infinite={videoSearch.length > 3 ? true : false}>
                              {videoSearch.map((item) => (
                                  <div key={item.id} className="course-item">
                                    <a
                                        data-gtm-type="click"
                                        data-gtm-clicktype="card"
                                        data-gtm-search="result"
                                        data-gtm-name={item.title}
                                        href={"/#/video/" + item.id + "/"}
                                    >
                                      <img src={item.thumbnail == null ? thumbnailDefault : item.thumbnail} />
                                      <div className="title">{item.title}</div>
                                    </a>
                                  </div>
                              ))}
                            </Slider>
                          </Col>
                        </Row>
                      </div>
                    </Grid>
                )}

                {aulasGravadasSearch.length > 0 && (
                    <Grid className="rowCarousel">
                      <div>
                        <Row>
                          <Col md={12}>
                            <h2 style={{ margin: 0 }}>Aulas Gravadas</h2>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <Slider {...settings_carousel} infinite={aulasGravadasSearch.length > 3 ? true : false}>
                              {aulasGravadasSearch.map((item) => (
                                  <div key={item.id} className="course-item">
                                    <a
                                        data-gtm-type="click"
                                        data-gtm-clicktype="card"
                                        data-gtm-search="result"
                                        data-gtm-name={item.title}
                                        href={"/#/video/" + item.id + "/"}
                                    >
                                      <img src={item.thumbnail} />
                                      <div className="title">{item.title}</div>
                                    </a>
                                  </div>
                              ))}
                            </Slider>
                          </Col>
                        </Row>
                      </div>
                    </Grid>
                )}

                {chatSearch.length > 0 && (
                    <Grid className="rowCarousel">
                      <div>
                        <Row>
                          <Col md={12}>
                            <h2 style={{ margin: 0 }}>Agenda</h2>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <Slider {...settings_carousel} infinite={chatSearch.length > 3 ? true : false}>
                              {chatSearch.map((item) => (
                                  <div key={item.id} className="course-item">
                                    <a
                                        data-gtm-type="click"
                                        data-gtm-clicktype="card"
                                        data-gtm-search="result"
                                        data-gtm-name={item.title}
                                        href={(item.externallink ? item.externallink : "/#/live/"+item.id)} target={(item.externallink ? "_blank" : "_self")}
                                    >
                                      <img src={item.thumbnail == null ? thumbnailDefault : Config.baseUrl + "/chat/assets/" + item.thumbnail} />
                                      <div className="title">{item.title}</div>
                                      <div style={{marginTop: '10px'}}> Data: {new Date(item.datetime_start_format).toLocaleDateString("pt-BR")}</div>
                                      <div> Horário: {new Date(item.datetime_start_format).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})} às {new Date(item.datetime_end_format).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})} </div>
                                    </a>
                                  </div>
                              ))}
                            </Slider>
                          </Col>
                        </Row>
                      </div>
                    </Grid>
                )}

                {trailSearch.length > 0 && (
                    <Grid className="rowCarousel">
                      <div>
                        <Row>
                          <Col md={12}>
                            <h2 style={{ margin: 0 }}>Trilhas</h2>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <Slider {...settings_carousel} infinite={trailSearch.length > 3 ? true : false}>
                              {trailSearch.map((item) => (
                                  <div>
                                    <CourseCard
                                      key={item.trail.id} 
                                      item={item.trail}
                                      href={"/#/trail/" + item.item_id + "/" + item.item_type + "/" + item.trail.id}
                                      src={item.trail.thumbnail == null ? thumbnailDefault : Config.baseUrl + "/lms/assets/" + item.trail.thumbnail}
                                      variables={{ course_trails: true }}
                                    />
                                  </div>
                              ))}
                            </Slider>
                          </Col>
                        </Row>
                      </div>
                    </Grid>
                )}
              </div>
          )}
        </div>
      </div>
  );
}

export default Search;



// WEBPACK FOOTER //
// ./src/views/Search/Search.jsx